import { render, staticRenderFns } from "./Flatform.vue?vue&type=template&id=32860e6a&scoped=true&"
import script from "./Flatform.vue?vue&type=script&lang=js&"
export * from "./Flatform.vue?vue&type=script&lang=js&"
import style0 from "./Flatform.vue?vue&type=style&index=0&id=32860e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32860e6a",
  null
  
)

export default component.exports